/* eslint-disable react-hooks/exhaustive-deps */
// export default IncidentRequest;
import DeleteModal from "components/DeleteModal";
import Loading from "components/Loading";
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import React, { useEffect, useRef, useState } from "react";
import { FaBriefcase } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
  deleteExternalPolice,
  fetchExternalPolice,
  fetchPoliceStation,
} from "services/externalUserService";
import { ExternalPolice, InvestigationFile, PoliceStation, Roles } from "types";
import { deleteIcon, editIcon } from "utils/constant";
import { errorHandler, hasRole } from "utils/helper";
import PageHeader from "../../components/PageHeader";
import ExternalPoliceForm from "./modal/ExternalPoliceForm";
import PoliceStations from "./PoliceSation";

const tab1 = "Police User List";
const tab2 = "Police Stations";
const tabs = [tab1, tab2];

const ExternalPoliceList: React.FC = () => {
  const { loginData } = useAuth();
  const { showTooltip } = useTooltip();
  const menuRef = useRef<HTMLDivElement | null>(null);

  const [activeTab, setActiveTab] = useState(tab1);

  const [externalPolice, setExternalPolice] = useState<ExternalPolice[]>([]);
  const [policeStations, setPoliceStations] = useState<PoliceStation[]>([]);
  const [loading, setLoading] = useState(true);
  const [action, setAction] = useState<"Add" | "Edit">("Add");
  const [fileTooltip, setFileTooltip] = React.useState<InvestigationFile>();
  const [isOpenForm, setIsOpenForm] = React.useState(false);
  const [selectedPolice, setSelectedPolice] = React.useState<ExternalPolice>();

  const [search, setSearch] = useState("");
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const navigate = useNavigate();

  const isExternalCoordinator =
    hasRole(loginData?.roles, [Roles.member]) ||
    loginData?.user?.role === "police_coordinator";

  const fetchData = () => {
    setLoading(true);
    fetchExternalPolice()
      .then((data) => {
        if (isExternalCoordinator) {
          data = data.filter(
            (police) =>
              police?.police_station_name ===
              loginData?.user?.police_station_name
          );

          setExternalPolice(data);
        } else setExternalPolice(data);
      })
      .catch((error) => {
        showTooltip(errorHandler(error));
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });

    fetchPoliceStation()
      .then((data) => {
        setPoliceStations(data);
      })
      .catch((error) => {
        showTooltip(errorHandler(error));
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [loginData]);

  const searchTerm = search.trim().toLowerCase();
  const filteredInvestigations = externalPolice.filter((investigation) => {
    // 1️⃣ — existing text‑search fields
    const title = investigation?.title?.toLowerCase() || "";
    const full_name = investigation?.full_name?.toString()?.toLowerCase() || "";
    // const police_station =
    //   investigation?.police_station?.?.toLowerCase() || "";
    const station_address = investigation?.station_address?.toLowerCase() || "";
    const phone_number = investigation?.phone_number?.toLowerCase() || "";
    const email = investigation?.email?.toLowerCase() || "";

    const matchesText =
      title.includes(searchTerm) ||
      full_name.includes(searchTerm) ||
      station_address.includes(searchTerm) ||
      email.includes(searchTerm) ||
      phone_number.includes(searchTerm);

    // 3️⃣ — only keep items that match BOTH
    return matchesText;
  });

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setFileTooltip(undefined);
      }
    }
    if (fileTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [fileTooltip]);

  const handleOpenForm = () => {
    setIsOpenForm(true);
  };
  const handleCloseForm = (refetch = false) => {
    setIsOpenForm(false);
    if (refetch) fetchData();
  };

  return (
    <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
      <PageHeader
        title="Police User List"
        icon={FaBriefcase}
        tabs={
          loginData?.user?.role === "police_coordinator"
            ? tabs?.slice(0, 1)
            : tabs
        }
        activeTab={activeTab}
        onTabClick={setActiveTab}
        rightContent={<></>}
      />

      {activeTab === tab1 && (
        <div>
          <div className="flex justify-end">
            <button
              onClick={() => {
                setAction("Add");
                handleOpenForm();
              }}
              className="mb-3  px-5 py-2 text-sm font-semibold text-white bg-red-600 rounded hover:bg-red-700"
            >
              Add {activeTab === tab1 ? "Police" : "Police Station"}
            </button>
          </div>
          <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
            <div className="overflow-hidden bg-white shadow rounded-xl">
              {loading ? (
                <Loading label="Loading External Police" />
              ) : (
                <table className="w-full text-sm border-collapse">
                  <thead className="text-white bg-black">
                    <tr>
                      <th colSpan={8} className="p-4" rounded-t-lg>
                        <div className="flex items-center justify-between">
                          {/* Left: Back + Title */}
                          <div className="flex items-center gap-2 text-lg font-semibold">
                            <button
                              onClick={() => navigate(-1)}
                              className="text-white hover:text-gray-300"
                              title="Go Back"
                            >
                              ◀️
                            </button>
                            <span>Police</span>
                          </div>

                          {/* Right: Search Box */}
                          <div className="relative w-80">
                            <span className="absolute inset-y-0 flex items-center text-gray-500 pointer-events-none left-3">
                              🔍
                            </span>
                            <input
                              type="text"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                              placeholder="Search"
                              className="w-full py-2 pl-10 pr-4 text-sm text-black placeholder-gray-600 bg-gray-200 rounded-md focus:outline-none"
                            />
                          </div>
                        </div>
                      </th>
                    </tr>
                    <tr>
                      {/* <th className="p-3 text-left">Reporter</th> */}
                      <th className="p-3 text-left">Title</th>
                      <th className="p-3 text-left">Full Name</th>
                      <th className="p-3 text-left">Police Station</th>
                      <th className="p-3 text-left">Phone Number</th>
                      <th className="p-3 text-left">Role</th>
                      <th className="p-3 text-left" rounded-tr-lg>
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredInvestigations.map((file, idx) => (
                      <tr
                        key={idx}
                        className={
                          idx % 2 === 0 ? "bg-[#F7F4F1AB]" : "bg-white"
                        }
                      >
                        <td className="p-3 font-[500] font-[Poppins]">
                          {file?.title}
                        </td>
                        <td className="p-3 font-[500] font-[Poppins]">
                          {file?.full_name}
                        </td>
                        <td className="p-3 font-[500] font-[Poppins]">
                          {typeof file.police_station === "object" &&
                          file.police_station !== null &&
                          "name" in file.police_station
                            ? (file.police_station as { name: string }).name
                            : file.police_station || ""}
                        </td>
                        <td className="p-3 font-[500] font-[Poppins]">
                          {file?.phone_number}
                        </td>
                        <td className="p-3 capitalize font-[500] font-[Poppins]">
                          {file?.role}
                        </td>
                        <td className="p-3 flex flex-row gap-2 font-[500] font-[Poppins]">
                          <button
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setAction("Edit");
                              setSelectedPolice({
                                ...file,
                                police_station_id:
                                  typeof file.police_station === "object" &&
                                  file.police_station !== null &&
                                  "id" in file.police_station
                                    ? (file.police_station as { id: number }).id
                                    : undefined,
                              });
                              setIsOpenForm(true);
                            }}
                          >
                            {editIcon}
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setSelectedPolice(file);
                              setIsOpenDelete(true);
                            }}
                          >
                            {deleteIcon}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}
      {activeTab === tab2 && (
        <PoliceStations fetchData={fetchData} policeSations={policeStations} />
      )}

      {isOpenForm && (
        <ExternalPoliceForm
          action={action}
          externalPolice={selectedPolice}
          policeStations={policeStations}
          onClose={(refetch) => {
            handleCloseForm(refetch);
            if (refetch) {
              fetchData();
            }
          }}
        />
      )}

      {selectedPolice && (
        <DeleteModal
          isOpen={isOpenDelete}
          onConfirm={() => {
            deleteExternalPolice(selectedPolice)
              .then(() => {
                showTooltip("Successfully Deleted!", "success");
                fetchData();
              })
              .catch((error) => {
                showTooltip(
                  error?.response?.data?.detail || errorHandler(error)
                );
              });
          }}
          onCancel={() => {
            setIsOpenDelete(false);
          }}
          title="Delete External Police"
          message={`Are you sure you want to delete external police called 
            ${selectedPolice?.title} ${selectedPolice?.full_name}`}
        />
      )}
    </div>
  );
};

export default ExternalPoliceList;
